import { connect, MapDispatchToProps, MapStateToProps } from 'react-redux';
import { PapiGallection } from '@wix/da-papi-types';
import { Props } from './MoveToFolderMenu';
import { AppState } from '../../../types/store';
import {
  getFeaturedFolderId,
  getIsRootStashFolder,
  getSelectedFolder,
} from '../../../selectors/studio';
import { getHasMoreSubfolders, getVisibleSubfolders } from '../../../selectors/stash';
import { fetchMoreSubfolders } from '../../../actions/stash';
import { STASH_SUBFOLDERS_STREAM } from '../../../../constants';

export type StateProps = Pick<
  Props,
  'selectedFolder' | 'subfolders' | 'featuredFolderId' | 'isRootStashFolder' | 'hasMoreSubfolders'
>;
export type DispatchProps = Pick<Props, 'fetchMoreSubfolders'>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, AppState> = state => ({
  selectedFolder: getSelectedFolder(state) as PapiGallection,
  subfolders: getVisibleSubfolders(state),
  featuredFolderId: getFeaturedFolderId(state),
  isRootStashFolder: getIsRootStashFolder(state),
  hasMoreSubfolders: getHasMoreSubfolders(state),
});

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = dispatch => ({
  fetchMoreSubfolders: () => dispatch(fetchMoreSubfolders(STASH_SUBFOLDERS_STREAM.streamId)),
});

export default connect(mapStateToProps, mapDispatchToProps);
